
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {CoachPlayersProfileMatchesListFormRemove} from "@/models/app/coach/players/profile/matches/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "match",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class CoachPlayersProfileMatchesListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  match: CoachPlayersProfileMatchesListFormRemove = new CoachPlayersProfileMatchesListFormRemove();

  formData: CoachPlayersProfileMatchesListFormRemove = new CoachPlayersProfileMatchesListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/match/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getMatches');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.match;
  }

  resetFormData(): void {
    this.formData = new CoachPlayersProfileMatchesListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
